var chunkMapping = {
	"5516": [
		205516
	],
	"5979": [
		105979
	],
	"15078": [
		515078
	],
	"40428": [
		540428
	],
	"52723": [
		52723
	],
	"57279": [
		857279
	],
	"59492": [
		159492
	],
	"64891": [
		264891
	],
	"65422": [
		165422
	],
	"70670": [
		370670
	],
	"73210": [
		573210
	],
	"89471": [
		489471
	],
	"95167": [
		95167
	]
};
var idToExternalAndNameMapping = {
	"52723": [
		"default",
		"./ClickhousePage",
		854311
	],
	"95167": [
		"default",
		"./SessionPlayerPage",
		854311
	],
	"105979": [
		"default",
		"./ServicesDashboardPage",
		854311
	],
	"159492": [
		"default",
		"./ThirdPartyServicesDashboard",
		854311
	],
	"165422": [
		"default",
		"./DBSearchPage",
		854311
	],
	"205516": [
		"default",
		"./TeamPage",
		854311
	],
	"264891": [
		"default",
		"./ServiceMapDashboard",
		854311
	],
	"370670": [
		"default",
		"./DigitalExperienceAnalytics",
		854311
	],
	"489471": [
		"default",
		"./CustomDashboardsExplore",
		854311
	],
	"515078": [
		"default",
		"./ErrorsPage",
		854311
	],
	"540428": [
		"default",
		"./ShortUrlResolver",
		854311
	],
	"573210": [
		"default",
		"./SessionsPage",
		854311
	],
	"857279": [
		"default",
		"./CustomDashboardsRouter",
		854311
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}